import React from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Avatar,
  Chip,
  Stack,
  Paper,
  Divider,
} from '@mui/material';
import {
  Code,
  Storage,
  Api,
  Security,
  LocationOn,
  Work,
  School,
} from '@mui/icons-material';
import { useThemeMode } from '../contexts/ThemeContext';

const About = () => {
  const { darkMode } = useThemeMode();



  const techStack = [
    'React', 'JavaScript', 'RESTful APIs', 'Material-UI', 'Git',
    'HTML5', 'CSS3', 'Node.js', 'Express.js', 'MongoDB', 'Redux',
  ];



  return (
    <Box id="about" sx={{
      py: 2,
      backgroundColor: darkMode
        ? 'rgba(25, 118, 210, 0.02)'
        : 'rgba(25, 118, 210, 0.01)'
    }}>
      <Container maxWidth="lg">
        <Box sx={{ textAlign: 'center', mb: 6 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2, mb: 2 }}>
            <LocationOn sx={{ fontSize: 32, color: 'primary.main' }} />
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: '2rem', md: '2.5rem' },
                fontWeight: 800,
                background: 'linear-gradient(45deg, #1976d2, #dc004e)',
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              About Me
            </Typography>
          </Box>
          <Typography
            variant="body1"
            sx={{
              color: 'text.secondary',
              maxWidth: 600,
              mx: 'auto',
              fontSize: '1.1rem',
            }}
          >
            Get to know more about my background, skills, and passion for development
          </Typography>
        </Box>

        <Grid container spacing={{ xs: 3, md: 4 }} sx={{ mb: 6 }}>
          <Grid item xs={12}>
            <Paper
              elevation={0}
              sx={{
                p: { xs: 3, sm: 4 },
                background: darkMode
                  ? 'linear-gradient(135deg, rgba(26,26,26,0.8) 0%, rgba(42,42,42,0.8) 100%)'
                  : 'linear-gradient(135deg, rgba(255,255,255,0.8) 0%, rgba(248,250,252,0.8) 100%)',
                border: `1px solid ${darkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)'}`,
                borderRadius: 3,
              }}
            >
              <Typography
                variant="h5"
                sx={{ mb: 3, fontWeight: 600, color: 'primary.main' }}
              >
                Frontend Developer (React & JavaScript)
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  mb: 3,
                  lineHeight: 1.7,
                  fontSize: '1rem',
                }}
              >
                Experienced frontend developer{' '}
                <Box
                  component="span"
                  sx={{
                    background: 'linear-gradient(45deg, #1976d2, #dc004e)',
                    backgroundClip: 'text',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    fontWeight: 700,
                  }}
                >
                  specializing in React.js and modern JavaScript
                </Box>
                , with a strong focus on building responsive, user-centric interfaces.
                Proficient in state management using Redux, component-driven architecture,
                and{' '}
                <Box
                  component="span"
                  sx={{
                    background: 'linear-gradient(45deg, #1976d2, #dc004e)',
                    backgroundClip: 'text',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    fontWeight: 700,
                  }}
                >
                  integrating RESTful APIs
                </Box>
                {' '}to deliver seamless user experiences.
                Known for improving UI performance, maintaining clean and scalable code,
                and collaborating effectively within cross-functional teams to build
                high-quality web applications.
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  mb: 3,
                  lineHeight: 1.7,
                  fontSize: '1rem',
                }}
              >
                Currently{' '}
                <Box
                  component="span"
                  sx={{
                    background: 'linear-gradient(45deg, #1976d2, #dc004e)',
                    backgroundClip: 'text',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    fontWeight: 700,
                  }}
                >
                  working as a MERN Stack Developer
                </Box>
                {' '}at EnergiSpeak Analytics, with previous
                experience at Acumen Cognitive Engineering as a Junior Software Developer. Based in
                Navi Mumbai, India, I enjoy challenging myself with new technologies and continuously
                improve my skills.
              </Typography>

              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
                <LocationOn sx={{ color: 'primary.main', fontSize: 20 }} />
                <Typography variant="body2" color="text.secondary">
                  Navi Mumbai, India
                </Typography>
              </Box>

              <Divider sx={{ my: 3 }} />

              <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
                Tech Stack
              </Typography>
              <Stack direction="row" spacing={1} flexWrap="wrap" gap={1}>
                {techStack.map((tech, index) => (
                  <Chip
                    key={index}
                    label={tech}
                    size="small"
                    sx={{
                      backgroundColor: darkMode ? 'rgba(100, 181, 246, 0.1)' : 'rgba(25, 118, 210, 0.1)',
                      color: 'primary.main',
                      border: `1px solid ${darkMode ? 'rgba(100, 181, 246, 0.3)' : 'rgba(25, 118, 210, 0.3)'}`,
                      fontWeight: 500,
                    }}
                  />
                ))}
              </Stack>
            </Paper>
          </Grid>


        </Grid>


      </Container>
    </Box>
  );
};

export default About;